import React, { useEffect, useState } from "react";
// import "./UserManagement.scss";
import { loginScreen, userPlaceholderIcon } from "assets/images";
import { Link, useParams } from "react-router-dom";
import { toastMessage } from "utils/toastMessage";
import useFullPageLoader from "common/UseFullPageLoader";
import { dateFormatWithTime } from "utils/dateFormat";
import { CustomModal } from "components/modals/ModalBox";
import { IoMdArrowRoundBack } from "react-icons/io";
import { blogDetailApi } from "services/blog";
const BlogDetail = () => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const { id } = useParams();
  const [formData, setFormData] = useState({});
  const [videoData, setVideoData] = useState("");
  const [imagePreview, setImagePreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  useEffect(() => {
    fetchPostDetails(id);
  }, [id]);
  const fetchPostDetails = async () => {
    try {
      const { data } = await blogDetailApi(id);
      const blog = data?.data?.blog || {};
      setFormData({
        id: id,
        title: blog.title || "",
        description: blog.description || "",
        bodyShape: blog.bodyShape,
        styleIdentity: blog.styleIdentity,
        flauntParts: blog.flauntParts,
        flauntPartsValue: blog.flauntParts,
        downplayParts: blog.downplayParts,
        downplayPartsValue: blog.downplayPartsValue,
        tag: blog.tag,
        category: blog.category,
        createdAt: blog.createdAt,
        media: blog.media || [],
        // thumb:blog.media,
        // media:blog.media
      });
    } catch (e) {
      toastMessage(e.message, "error", "blog Detail");
    }
  };
  return (
    <>
      {loader}
      <div className="editProfile user_management">
        <div className="dashboard_title">
          <h3>
            <Link to={"/blog-management"}>
              <IoMdArrowRoundBack />
            </Link>{" "}
            Blog details
          </h3>
          {/* <Link
            to={`/blog-management/edit/${formData?.blogId}`}
            className="icon_button"
          >
            <button className="button">
              Update
            </button>
          </Link> */}
        </div>
        <div className="card">
          <div className="card-body">
            <div className="personal_details _box spacing">
              <div className="details_list">
                <ul>
                  <li>
                    <b>Blog Name</b>
                    <span>{formData?.title}</span>
                  </li>
                  <li>
                    <b>Description</b>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: formData?.description,
                      }}
                    />
                  </li>
                  <li>
                    <b>Tag</b>
                    <span>{formData?.tag}</span>
                  </li>
                  <li>
                    <b>Body Shape</b>
                    <span>
                    {formData?.bodyShape?.length
                    ? formData.bodyShape.join(",") || " "
                    : " "}</span>
                  </li>
                  <li>
                    <b>Style Identity</b>
                    <span>{formData?.styleIdentity}</span>
                  </li>

                  <li>
                    <b>Flaunt Parts</b>
                    <span>
                    {formData?.flauntParts?.length
                    ? formData.flauntParts.join(",") || " "
                    : " "}</span>
                  </li>

                  <li>
                    <b>Downplay Parts</b>
                    <span>
                    {formData?.downplayParts?.length
                    ? formData.downplayParts.join(",") || " "
                    : " "}</span>
                  </li>

                  <li>
                    <b>Category</b>
                    <span>{formData?.category}</span>
                  </li>
                  <li>
                    <b>Published</b>
                    <span>{dateFormatWithTime(formData?.createdAt)}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="tab_content">
              <div className="post_details">
                {/* Render  data */}
                <div className="post_item">
                  <label className="label">Media</label>

                  <div className="image_gallery">
                    <ul className="image_list">
                      {formData?.media?.map((md, index) => (
                        <div
                          className="image_preview"
                          key={index}
                          onClick={() => {
                            setImagePreview(true);
                            setImageUrl(
                              md?.type === "image" ? md?.url : md.thumb
                            );
                          }}
                        >
                          {/* Display image preview */}
                          {md?.type === "image" ? (
                            <img
                              src={md?.url}
                              alt="Preview"
                              className="post_image"
                            />
                          ) : (
                            // Display video preview
                            <img
                              src={md?.thumb}
                              alt="Preview"
                              className="post_image"
                            />
                          )}
                        </div>
                      ))}
                      {/* <li
                        onClick={() => {
                          setImagePreview(true);
                          setImageUrl(formData?.image);
                        }}
                      >
                        <img
                          src={formData?.media ? formData?.media : loginScreen}
                          // alt={`image`}
                          className="post_image"
                        />
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
        className={"image_preview_modal"}
      >
        <img src={imageUrl ? imageUrl : loginScreen} alt="" />
      </CustomModal>
    </>
  );
};

export default BlogDetail;
